<form [formGroup]="form" novalidate (ngSubmit)="submit()" class="globalForm">
  <formly-form
    [model]="modelSelf"
    [fields]="vm.fields()"
    [options]="options"
    [form]="form"
  ></formly-form>
  <div class="form-actions">
    <button
      *ngFor="let btn of additionalButtons"
      type="button"
      class="btn submit-button ghost"
      (click)="btn.action()"
    >
      {{ btn.name | translate }}
    </button>
    <a
      class="btn submit-button ghost"
      (click)="close()"
      *ngIf="closeRouteThis"
      >{{ "GENERIC.CLOSE" | translate }}</a
    >
    <button
      type="submit"
      class="btn submit-button primary"
      *ngIf="!disableSubmitButton && canSubmit"
      [class.loading]="loadingIndicator"
    >
      <i class="fas fa-check" aria-hidden="true"></i>
      {{ "GENERIC.SUBMIT" | translate }}
    </button>
  </div>
</form>
